import type { ISingleResult } from "./types.js";

type Result = ISingleResult & {
	linkText: string;
};

/**
 * Renders a single result.
 *
 * @param element The result to render.
 * @returns The rendered result HTML.
 */
export function render(element: ISingleResult): string {
	const adjusted: Partial<Result> = { ...element };
	adjusted.image ||=
		"/wp-content/themes/rootree/assets/woocommerce-placeholder-300x300.png";

	switch (element.type) {
		case "product":
			adjusted.linkText = "View Product";
			break;
		case "post":
			adjusted.linkText = "View Post";
			break;
		case "page":
			adjusted.linkText = "View Page";
			break;
		case "portfolio":
			adjusted.linkText = "View Portfolio";
			break;
		default:
			adjusted.linkText = "View";
	}
	return template(adjusted as Result);
}

/**
 * Creates the HTML for a single result.
 *
 * @param element The result to render.
 * @returns The rendered result HTML.
 */
function template(element: Result) {
	const { image, title, permalink, blurb, linkText } = element;
	let resultHtml = `<div class="rt-search-popup-result">`;
	resultHtml += `<div class="rt-search-popup-result-thumbnail">`;
	resultHtml += `    <a href="${permalink}"><img src="${image}" alt="${title}" width="600" height="300"></a>`;
	resultHtml += `</div>`;
	resultHtml += `<div class="rt-search-popup-result-details">`;
	resultHtml += `    <h4 class="rt-search-popup-result-title"><a href="${permalink}">${title}</a></h4>`;
	resultHtml += `    <p class="rt-search-popup-result-excerpt">`;
	resultHtml += `       ${blurb}`;
	resultHtml += `    </p>`;
	resultHtml += `    <div class="rt-search-popup-result-link"><a href="${permalink}" class="rt-button">${linkText}</a></div>`;
	resultHtml += `</div>`;
	resultHtml += `</div>`;
	return resultHtml;
}
